export const VUE_APP_MARKETPLACE_LINK = process.env.VUE_APP_MARKETPLACE_LINK || 'https://api-marketplace.ibbil.com/api/v1/'
export const VUE_APP_SSO_LINK = process.env.VUE_APP_SSO_LINK || 'https://auth.ibbil.com/'
export const VUE_APP_WEBSITE_LINK = process.env.VUE_APP_WEBSITE_LINK || 'https://api-web.ibbil.com/api/v1'
